module.exports = __webpack_public_path__ + "img/图片24.0f80ab5e.png";